import { i18n } from '@/plugins/vue-i18n'

export enum NoFacturaEStatusEnum {
  NOT_APPLY = 'not_apply',
}

export const nofacturaEStatusDisplay: { [key in NoFacturaEStatusEnum]: string | undefined } = {
  [NoFacturaEStatusEnum.NOT_APPLY]: i18n.t('grid.columns.tags.notApply').toString()
}
